import { useMutation, useQueryClient } from '@tanstack/react-query'

import { cancelInsurance } from '@flecto/api/saas'
import { type ParameterID } from '@flecto/types'

type MutationPayload = {
  id: ParameterID
  bookingId?: ParameterID
}

export function useMutationCancelInsurance() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: ['MutationCancelInsurance'],
    mutationFn: async ({ id, bookingId }: MutationPayload) => {
      await cancelInsurance(id)
      queryClient.invalidateQueries(['QueryGetAllInsurances'])
      queryClient.invalidateQueries(['QueryGetInsuranceById', `${id}`])

      if (bookingId) {
        queryClient.invalidateQueries([
          'QueryGetAllBookingInsurances',
          Number(bookingId ?? ''),
        ])
      }
    },
  })
}
